import { PlusOutlined } from '@ant-design/icons';
import Avatar from 'antd/lib/avatar/avatar';
import Upload, { UploadChangeParam } from 'antd/lib/upload';
import { useField } from 'formik';
import { get } from 'lodash';
import React, { useState } from 'react';

import { ICommonInputProps } from './types';

const AvatarInput: React.FC<ICommonInputProps> = ({ name, onChange }) => {
  const [, , helpers] = useField(name);
  const [selectedFile, setSelectedFile] = useState('');
  const reader = new FileReader();

  function getBase64(img: any, callback: (result: any) => void) {
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const props = {
    name,
    headers: {
      authorization: 'authorization-text',
    },
    onChange(info: UploadChangeParam) {
      helpers.setValue(info.fileList);
      const fileObj = get(info.fileList[info.fileList.length - 1], 'originFileObj', {});
      getBase64(fileObj, (imageUrl: string) => setSelectedFile(imageUrl));
      if (onChange) {
        onChange(info.fileList);
      }
    },
  };

  return (
    <Upload
      listType='picture-card'
      className='avatar-uploader gx-avatar-upload-preview'
      showUploadList={false}
      accept='image/jpeg, image/png'
      beforeUpload={() => false}
      {...props}>
      {selectedFile ? (
        <Avatar size={200} src={selectedFile} />
      ) : (
        <div>
          <PlusOutlined />
        </div>
      )}
    </Upload>
  );
};

export default React.memo(AvatarInput);
